var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#202a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "203b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#203b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#64BEE7",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.857 10.665V6.932c0-.89-.704-1.6-1.571-1.6H15.19c-.866 0-1.572.715-1.572 1.6v3.733c0 .195 1.048 2.134 2.62 2.134 1.57 0 2.618-1.945 2.618-2.134",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "M16.762 8.532v1.193h2.095v1.026h-2.095v2.048h-1.048V10.75H13.62V9.725h2.095V8.532H13.62v-3.2h5.238v3.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD200",
    fillRule: "evenodd",
    d: "M14.667 6.398h3.142v1.067h-3.143z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.429 1.066H2.095c-.578 0-1.047.478-1.047 1.067v5.333c0 .59.469 1.067 1.047 1.067H9.43c.578 0 1.047-.477 1.047-1.067V2.133c0-.589-.469-1.067-1.047-1.067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "M5.238 5.333H2.095V4.266h3.143V2.133h1.048v2.133h3.143v1.067H6.286v2.133H5.238zm2.62 1.066v1.067h1.57V6.4zm0-4.266v1.066h1.57V2.133zM2.094 6.399v1.067h1.572V6.4zm0-4.266v1.066h1.572V2.133z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "202a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagFj = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagFj);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";